import React, { useEffect, useState } from "react";
import { Form, Input, Button, message } from "antd";

const GeneralInfo = ({ companyData, apiUrl }) => {
  // console.log(companyData[0].contactInfo);
  
  const [formData, setFormData] = useState({
    companyId: "",
    companyName: "",
    city: "",
    district: "",
    country: "",
    fullAddress: "",
    postalCode: "",
    email: "",
    phone: "",
    website: "",
    instagram: "",
    linkedin: "",
    twitter: "",
  });

  useEffect(() => {
    if (companyData.length) {
      setFormData({
        companyId: companyData[0]?._id || "",
        companyName: companyData[0]?.companyName || "",
        city: companyData[0]?.address?.city || "",
        district: companyData[0]?.address?.district || "",
        country: companyData[0]?.address?.country || "",
        fullAddress: companyData[0]?.address?.fullAddress || "",
        postalCode: companyData[0]?.address?.postalCode || "",
        email: companyData[0]?.contactInfo?.email || "",
        phone: companyData[0]?.contactInfo?.phone || "",
        website: companyData[0]?.contactInfo?.website || "",
        socialMedia: companyData[0]?.contactInfo?.socialMedia || "",
      });
    }
  }, [companyData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/companyProfile/update/${companyData[0]?._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyName: formData.companyName,
            address: {
              city: formData.city,
              district: formData.district,
              country: formData.country,
              fullAddress: formData.fullAddress,
              postalCode: formData.postalCode,
            },
            contactInfo: {
              email: formData.email,
              phone: formData.phone,
              website: formData.website,
              socialMedia: {
                instagram: formData.instagram,
                linkedin: formData.linkedin,
                twitter: formData.twitter,
              },
            },
          }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        message.success("Genel Bilgiler Başarıyla Güncellendi!");
      } else {
        message.error(
          result.message || "Genel Bilgiler Güncellenirken Bir Hata Oluştu."
        );
      }
    } catch (error) {
      console.error("Error updating general info:", error);
      message.error("Genel Bilgiler Güncellenirken Bir Hata Oluştu.");
    }
  };

  if (!companyData.length) return <p>Loading...</p>;

  return (
    <Form layout="vertical" className="grid grid-cols-2 gap-4">
      <Form.Item label="Firma Kodu">
        <Input name="companyName" value={formData.companyId} disabled />
      </Form.Item>
      <Form.Item label="Firma İsmi">
        <Input
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item label="Şehir">
        <Input name="city" value={formData.city} onChange={handleChange} />
      </Form.Item>
      <Form.Item label="İlçe">
        <Input
          name="district"
          value={formData.district}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item label="Ülke">
        <Input
          name="country"
          value={formData.country}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item label="Adres">
        <Input.TextArea
          name="fullAddress"
          rows={3}
          value={formData.fullAddress}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item label="Posta Kodu">
        <Input
          name="postalCode"
          value={formData.postalCode}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item label="Email">
        <Input name="email" value={formData.email} onChange={handleChange} />
      </Form.Item>
      <Form.Item label="Telefon">
        <Input name="phone" value={formData.phone} onChange={handleChange} />
      </Form.Item>
      <Form.Item label="Website">
        <Input
          name="website"
          value={formData.website}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item label="Sosyal Medyalar">
        <Input.TextArea
          name="socialMedia"
          rows={3}
          value={formData.socialMedia}
          onChange={handleChange}
        />
      </Form.Item>
      <Button type="primary" className="col-span-2" onClick={handleSubmit}>
        Değişiklikleri Kaydet
      </Button>
    </Form>
  );
};

export default GeneralInfo;
